import styled from "styled-components";

export const Button = styled.button`
  cursor: ${({disabled}) => disabled ? 'unset' : 'pointer'};
  background-color: unset;
  border: 0;
  padding: 0;
  margin: 0;
`

export const TextButton = styled(Button)`
	color: unset;
`

export const Container = ({children}) => (<div className={"container"}>{children}</div>);

export const Row = ({children}) => (<div className={"row"}>{children}</div>);
